import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Hammer, Award, Heart } from 'lucide-react';
const credentials = [{
  icon: Clock,
  text: '+10 Años de Experiencia en Trabajo en Cuero'
}, {
  icon: Hammer,
  text: 'Productos Hechos con Propósito'
}, {
  icon: Award,
  text: 'Diseños que Marcan la Diferencia'
}, {
  icon: Heart,
  text: 'Artesanía que Conecta y Transforma'
}];
export function ArtisanSection() {
  return <section className="bg-[#1A1A1A] py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-14">
      {/* Subtle texture */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#C9A84C 0.5px, transparent 0.5px)',
      backgroundSize: '20px 20px'
    }} data-id="element-15"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-16">
        {/* Top label */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        type: 'spring',
        stiffness: 100,
        damping: 15
      }} className="text-center mb-16" data-id="element-17">
          <p className="text-gold uppercase tracking-[0.3em] font-bold text-sm mb-2" data-id="element-18">
            Artesano Oficial
          </p>
          <p className="text-cream/60 uppercase tracking-widest text-xs" data-id="element-19">
            Diseña. Crea. Transforma.
          </p>
          <div className="w-8 h-8 mx-auto mt-4 text-gold" data-id="element-20">
            <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 mx-auto" data-id="element-21">
              <path d="M12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2Z" data-id="element-22" />
            </svg>
          </div>
        </motion.div>

        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-23">
          {/* Left: Avatar image */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          type: 'spring',
          stiffness: 100,
          damping: 15
        }} className="lg:w-1/2 flex justify-center" data-id="element-24">
            <div className="relative" data-id="element-25">
              <div className="w-72 h-72 sm:w-80 sm:h-80 rounded-full overflow-hidden border-4 border-gold/60 shadow-[0_0_40px_rgba(201,168,76,0.3)]" data-id="element-26">
                <img src="https://cdn.magicpatterns.com/uploads/ooJE3amhDta86DuWKRp5Ej/ChatGPT_Image_1_may_2026,_00_48_13_(1)_(1).webp" alt="Mateo Ruiz - Artesano en Cuero" className="w-full h-full object-cover" data-id="element-27" />
              </div>
              {/* Decorative ring */}
              <div className="absolute inset-0 w-72 h-72 sm:w-80 sm:h-80 rounded-full border-2 border-gold/20 scale-110" data-id="element-28"></div>
            </div>
          </motion.div>

          {/* Right: Info */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          type: 'spring',
          stiffness: 100,
          damping: 15,
          delay: 0.15
        }} className="lg:w-1/2 text-center lg:text-left" data-id="element-29">
            <h3 className="font-heading text-4xl sm:text-5xl font-black text-cream mb-1" data-id="element-30">
              Mateo Ruiz
            </h3>
            <p className="text-gold uppercase tracking-widest font-bold text-sm mb-8" data-id="element-31">
              Artesano en Cuero
            </p>

            {/* Quote */}
            <div className="mb-10 relative" data-id="element-32">
              <span className="text-gold/30 text-6xl font-heading absolute -top-4 -left-2 leading-none" data-id="element-33">
                "
              </span>
              <p className="text-cream/90 text-xl sm:text-2xl font-heading italic leading-relaxed pl-8" data-id="element-34">
                No es solo cuero.
                <br data-id="element-35" />
                Es diseño, intención y pasión.
              </p>
              <span className="text-gold/30 text-6xl font-heading absolute -bottom-8 right-0 lg:right-auto lg:left-64 leading-none" data-id="element-36">
                "
              </span>
            </div>

            {/* Credentials */}
            <div className="space-y-5 mt-12" data-id="element-37">
              {credentials.map((cred, index) => {
              const Icon = cred.icon;
              return <motion.div key={index} initial={{
                opacity: 0,
                x: 20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                type: 'spring',
                stiffness: 100,
                damping: 15,
                delay: 0.2 + index * 0.1
              }} className="flex items-center gap-4" data-id="element-38">
                    <div className="w-10 h-10 rounded-lg bg-gold/15 border border-gold/30 flex items-center justify-center flex-shrink-0" data-id="element-39">
                      <Icon className="w-5 h-5 text-gold" data-id="element-40" />
                    </div>
                    <span className="text-cream/80 font-medium text-lg uppercase tracking-wide" data-id="element-41">
                      {cred.text}
                    </span>
                  </motion.div>;
            })}
            </div>
          </motion.div>
        </div>

        {/* Bottom quote banner */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        type: 'spring',
        stiffness: 100,
        damping: 15,
        delay: 0.3
      }} className="mt-20 bg-gold/10 border-t border-b border-gold/30 py-8 px-6 text-center" data-id="element-42">
          <p className="text-cream text-xl sm:text-2xl font-heading font-bold leading-relaxed max-w-3xl mx-auto" data-id="element-43">
            <span className="text-gold/40 text-4xl mr-2" data-id="element-44">"</span>
            Los diseños correctos convierten tu trabajo en{' '}
            <span className="text-gold font-black" data-id="element-45">
              productos que la gente quiere y valora.
            </span>
            <span className="text-gold/40 text-4xl ml-2" data-id="element-46">"</span>
          </p>
        </motion.div>
      </div>
    </section>;
}